<template>
	<div class="date-time-picker">
		<el-date-picker v-on="$listeners" v-bind="$attrs" @change="changeTime" :picker-options="pickerOptions"></el-date-picker>
	</div>
</template>

<script>
/**
 * @param {quickSelect}
 * "今天"=>"0d"
 * "最近一天"=>"1d"
 * "最近3天"=>"3d"
 * "最近七天"=>"7d"
 * "最近30天"=>"30d"
 * "本周"=>"0w"
 * "本月"=>"0m"
 * "最近3个月"=>"3m"
 * "最近一年"=>"1y"
 * @param {includeDay}
 * 是否自动加一天
 */
export default {
	inheritAttrs: false,
	props: {
		quickSelect: {
			type: Array,
			requird: false
		},
		includeDay: {
			type: Boolean,
			requird: true,
			default: true
		}
	},
	data() {
		return {
			picker: []
		};
	},
	methods: {
		changeTime(time) {
			let newTime = JSON.parse(JSON.stringify(time));
			if (newTime) {
				if (this.$attrs["type"] === "daterange") {
					newTime[0] = this.formatTime(newTime[0], 0);
					newTime[1] = this.formatTime(
						new Date(newTime[1]).setTime(
							new Date(newTime[1]).getTime() + 3600 * 1000 * 24
						),
						1
					);
					this.$emit("picker", newTime);
				} else if (this.$attrs["type"] === "monthrange") {
					newTime[0] = this.formatTime(newTime[0], 0);
					newTime[1] = this.formatTime(
						new Date(newTime[1]).setMonth(
							new Date(newTime[1]).getMonth() + 1
						),
						1
					);
					this.$emit("picker", newTime);
				}
			} else {
				this.$emit("picker", null);
			}
			this.picker = newTime;
			this.$emit("input", time);
		},
		computedDay(day, picker, index) {
			let end = new Date();
			let start = new Date();
			start.setTime(start.getTime() - 3600 * 1000 * 24 * day);
			picker.$emit("pick", [
				this.formatTime(start, 0),
				this.formatTime(end, index)
			]);
		},
		formatTime(value, index) {
			let defaultTime = ["00:00:00", "00:00:00"];
			let time = new Date(value);
			let yyyy = time.getFullYear();
			let mm = time.getMonth() + 1;
			let dd = time.getDate();
			let h = time.getHours();
			let m = time.getMinutes();
			let s = time.getSeconds();
			if (mm < 10) {
				mm = "0" + mm;
			}
			if (dd < 10) {
				dd = "0" + dd;
			}
			if (h < 10) {
				h = "0" + h;
			}
			if (m < 10) {
				m = "0" + m;
			}
			if (s < 10) {
				s = "0" + s;
			}
			let hsm = ""; //时分秒
			if (index === 0 || index === 1) {
				hsm = defaultTime[index];
			} else {
				hsm = `${h}:${m}:${s}`;
			}
			return `${yyyy}-${mm}-${dd} ${hsm}`;
		}
	},
	computed: {
		pickerOptions() {
			let options = {};
			if (this.quickSelect) {
				options = {
					shortcuts: []
				};
				const that = this;
				for (const iterator of this.quickSelect) {
					switch (iterator) {
						case "0d":
							options.shortcuts.push({
								text: "今天",
								onClick(picker) {
									let end = new Date();
									let start = new Date();
									picker.$emit("pick", [
										that.formatTime(start, 0),
										that.formatTime(end)
									]);
								}
							});
							break;
						case "1d":
							options.shortcuts.push({
								text: "昨天",
								onClick(picker) {
									let start = new Date();
									let end = new Date();
									start = start.setDate(start.getDate() - 1);
									end = end.setDate(end.getDate() - 1);
									picker.$emit("pick", [
										that.formatTime(start, 0),
										that.formatTime(end)
									]);
								}
							});
							break;
						case "3d":
							options.shortcuts.push({
								text: "最近三天",
								onClick(picker) {
									that.computedDay(2, picker);
								}
							});
							break;
						case "7d":
							options.shortcuts.push({
								text: "最近七天",
								onClick(picker) {
									that.computedDay(6, picker);
								}
							});
							break;
						case "30d":
							options.shortcuts.push({
								text: "最近30天",
								onClick(picker) {
									that.computedDay(29, picker);
								}
							});
							break;
						case "0w":
							options.shortcuts.push({
								text: "本周",
								onClick(picker) {
									let end = new Date();
									let start = new Date();
									let weekDay = new Date().getDay();
									start.setTime(
										start.getTime() -
											(weekDay == 0 ? 7 : weekDay - 1) *
												24 *
												3600 *
												1000
									);
									picker.$emit("pick", [
										that.formatTime(start, 0),
										that.formatTime(end)
									]);
								}
							});
							break;
						case "0m":
							options.shortcuts.push({
								text: "本月",
								onClick(picker) {
									let end = new Date();
									let start = new Date();
									start.setDate(1);
									picker.$emit("pick", [
										that.formatTime(start, 0),
										that.formatTime(end)
									]);
								}
							});
							break;
						case "1m":
							options.shortcuts.push({
								text: "最近1个月",
								onClick(picker) {
									let end = new Date();
									let start = new Date();
									start.setMonth(start.getMonth());
									picker.$emit("pick", [
										that.formatTime(start, 0),
										that.formatTime(end)
									]);
								}
							});
							break;
						case "3m":
							options.shortcuts.push({
								text: "最近3个月",
								onClick(picker) {
									let end = new Date();
									let start = new Date();
									start.setMonth(start.getMonth() - 3);
									picker.$emit("pick", [
										that.formatTime(start, 0),
										that.formatTime(end)
									]);
								}
							});
							break;
						case "1y":
							options.shortcuts.push({
								text: "最近1年",
								onClick(picker) {
									let end = new Date();
									let start = new Date();
									start.setFullYear(start.getFullYear() - 1);
									picker.$emit("pick", [
										that.formatTime(start, 0),
										that.formatTime(end)
									]);
								}
							});
						default:
							break;
					}
				}
			} else if (this.$attrs["picker-options"]) {
				options = this.$attrs["picker-options"];
			}
			return options;
		},
		hasToday: {
			get() {
				return this.includeDay;
			},
			set(val) {
				return val;
			}
		}
	}
};
</script>

<style scoped>
.date-time-picker {
	display: inline-flex;
}
</style>
